import React, { useEffect, useState } from 'react'
// import { UpgradePremium } from '../../assests/ExportImageIcon'
import '../profile/mainProfile.css'
import './wishlist.css'
import Individual from './wishlistPersonal/individual'
import Collaboration from './wishlistPersonal/collaboration'
import service from '../../services/service'
import endpoints from '../../services/endpoints'

const Wishlist = () => {
    const [activeTab, setActiveTab] = useState('individual')
    const [wishlists, setWishlists] = useState({ individual: [], collaborator: [] })
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        service
            .get(endpoints.wishlists.list, {}, { silent: true })
            .then(({ data }) => {
                // /wishlists/ returns a flat array, each item tagged with
                // type: "individual" | "collaborator"/"collaboration" — not
                // pre-split into buckets, so split it here.
                const all = Array.isArray(data.data) ? data.data : []
                setWishlists({
                    individual: all.filter((w) => w.type === 'individual'),
                    collaborator: all.filter((w) => w.type !== 'individual'),
                })
            })
            .catch(() => setWishlists({ individual: [], collaborator: [] }))
            .finally(() => setLoading(false))
    }, [])

    const TABS = [
        { key: 'individual', label: `Individual (${wishlists.individual.length})` },
        { key: 'collaborations', label: `Collaborations (${wishlists.collaborator.length})` },
    ]

    return (
        <>
        <section className='allSearchArea commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    {/* Upgrade to Premium — not a real feature yet, comment out until built */}
                    {/* <div className='col-md-12'>
                        <div className='upgradePremium paddingCommon20 borderRadius20'>
                            <div className='upgradePremium__left'>
                                <span className='upgradePremium__icon'><img src={UpgradePremium} alt="" /></span>
                                <div>
                                    <div className='upgradePremium__title'>Upgrade to Premium</div>
                                    <div className='upgradePremium__subtitle'>Unlock unlimited AI features, priority support, and exclusive discounts</div>
                                </div>
                            </div>
                            <button type='button' className='commonBtn upgradePremium__btn'>View Plans @399</button>
                        </div>
                    </div> */}

                    <div className='col-md-12'>
                        <div className='commonBookingTab commonBookingTab--split'>
                            {TABS.map((tab) => (
                                <div
                                    key={tab.key}
                                    className={`bookTab ${activeTab === tab.key ? 'active' : ''}`}
                                    onClick={() => setActiveTab(tab.key)}
                                >
                                    {tab.label}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='col-md-12'>
                        {activeTab === 'individual'
                            ? <Individual items={wishlists.individual} loading={loading} />
                            : <Collaboration items={wishlists.collaborator} loading={loading} />}
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default Wishlist
